import React from 'react';

type ICibilAlertsIcon = {
  size?: string;
  className?: string;
};

const CibilAlertsIcon: React.FC<ICibilAlertsIcon> = props => {
  const { size = '28', className } = props;
  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width={size} height={size} rx="14" fill="#E6F1FF" />
      <g clipPath="url(#clip0_4678_145392)">
        <path
          d="M6.99996 7.09375C6.99996 6.92799 7.06581 6.76902 7.18302 6.65181C7.30023 6.5346 7.4592 6.46875 7.62496 6.46875C7.79072 6.46875 7.94969 6.5346 8.0669 6.65181C8.18411 6.76902 8.24996 6.92799 8.24996 7.09375V7.575L19.5937 11.2375C19.6575 11.2575 19.7131 11.2975 19.7525 11.3515C19.7918 11.4055 19.8129 11.4707 19.8125 11.5375V15.2875C19.8136 15.3537 19.7927 15.4185 19.7531 15.4716C19.7135 15.5248 19.6575 15.5633 19.5937 15.5813L18.7812 15.8375C18.7175 15.8575 18.6618 15.8975 18.6225 15.9515C18.5831 16.0055 18.5621 16.0707 18.5625 16.1375V17.7562C18.551 18.4951 18.2498 19.2 17.7238 19.719C17.1978 20.238 16.4889 20.5297 15.75 20.5312C15.0045 20.5263 14.2915 20.2263 13.7667 19.6968C13.242 19.1674 12.9483 18.4517 12.95 17.7062V17.6437L8.24996 19.125V19.6063C8.24996 19.772 8.18411 19.931 8.0669 20.0482C7.94969 20.1654 7.79072 20.2313 7.62496 20.2313C7.4592 20.2313 7.30023 20.1654 7.18302 20.0482C7.06581 19.931 6.99996 19.772 6.99996 19.6063V7.09375ZM14.1875 17.7188C14.1875 18.1332 14.3521 18.5306 14.6451 18.8236C14.9381 19.1166 15.3356 19.2812 15.75 19.2812C16.1622 19.2813 16.5577 19.1184 16.8504 18.828C17.1431 18.5377 17.3092 18.1435 17.3125 17.7313V16.7C17.312 16.6516 17.3005 16.6039 17.2788 16.5606C17.2572 16.5173 17.2259 16.4794 17.1875 16.45C17.1482 16.4194 17.102 16.3989 17.053 16.3902C17.004 16.3815 16.9536 16.3849 16.9062 16.4L14.4062 17.1875C14.3424 17.2054 14.2864 17.244 14.2468 17.2971C14.2072 17.3503 14.1864 17.415 14.1875 17.4813V17.7188Z"
          fill="#0276FE"
        />
        <path
          d="M20.75 11.1562C20.75 10.9905 20.8158 10.8315 20.9331 10.7143C21.0503 10.5971 21.2092 10.5312 21.375 10.5312C21.5408 10.5312 21.6997 10.5971 21.8169 10.7143C21.9342 10.8315 22 10.9905 22 11.1562V15.5312C22 15.697 21.9342 15.856 21.8169 15.9732C21.6997 16.0904 21.5408 16.1562 21.375 16.1562C21.2092 16.1562 21.0503 16.0904 20.9331 15.9732C20.8158 15.856 20.75 15.697 20.75 15.5312V11.1562Z"
          fill="#0276FE"
        />
      </g>
      <defs>
        <clipPath id="clip0_4678_145392">
          <rect width="15" height="15" fill="white" transform="matrix(-1 0 0 1 22 6)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default CibilAlertsIcon;
